import React from 'react';

import WidgetNewportAppSettingsEditor from 'widgets/WidgetSettingsEditing/WidgetNewportAppSettingsEditor';
import { useWidgetConfigUpdater } from 'widgets/WidgetSettingsEditing/useWidgetConfigUpdater';

import { useVenueTypeCapsuleConfigSlice } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/store/config/configslice';
import WidgetSettingsCheckboxValueEditor from 'widgets/WidgetSettingsEditing/WidgetSettingsCheckboxValueEditor';
import { VenueAnalysisCapsuleConfigState } from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';
import { CapsuleSettingsSymbolEditor } from 'widgets/tiles/components/tile/CapsuleSettingsSymbolEditor';

export const VenueTypeCapsuleSettingsText = `Fills by Venue Type Capsule Settings`;

export interface VenueTypeCapsuleSettingsProps {
    config?: VenueAnalysisCapsuleConfigState;
    onChange?: (nextDelta: Partial<VenueAnalysisCapsuleConfigState>) => void;
}

export default function VenueTypeCapsuleSettings(
    props: VenueTypeCapsuleSettingsProps
) {
    const { onChange, config: propsConfig } = props;
    const { config: configSliceConfig, dispatchConfigChanged } =
        useVenueTypeCapsuleConfigSlice();

    const { debouncedApplyWidgetConfigChange } = useWidgetConfigUpdater(
        dispatchConfigChanged,
        onChange
    );
    const config = propsConfig ?? configSliceConfig;

    return (
        <div className="VenueTypeCapsuleSettings">
            <div className="group ">
                <CapsuleSettingsSymbolEditor
                    config={config}
                    onChange={debouncedApplyWidgetConfigChange}
                />
            </div>

            <WidgetSettingsCheckboxValueEditor
                propertyName="includePreviousDaysFills"
                config={config!}
                label="Show portion of order filled in previous days' trading"
                onChange={debouncedApplyWidgetConfigChange}
            />

            <WidgetNewportAppSettingsEditor />
        </div>
    );
}
